import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type RfqDeleteParams = {
  uuid: string
}

export const useRfqDeleteMutation = () =>
  useMutation<any, ErrorDTO, RfqDeleteParams>({
    mutationFn: async (params) => {
      try {
        const res = await client.delete(`/rfq/delete/${params.uuid}`)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
